<template>
  <Modal
    width="1226"
    title="素材选择"
    class-name="vertical-center-modal"
    v-model="state"
    loading
    :closable="false"
    :mask-closable="false"
    @on-visible-change="bindGetData"
  >
    <!-- <Spin size="large" fix v-if="!show"></Spin> -->
    <Form inline :label-width="40" class="filter-box" @submit.native.prevent>
      <drop-autoComplete
        label="游戏"
        game
        :width="140"
        :default-option="defaultGameId"
        placeholder="请输入游戏名称"
        @on-change="handleGame"
      />
      <drop-autoComplete
        label="游戏组"
        group
        :width="140"
        :label-width="55"
        :default-option="defaultGameGroupId"
        placeholder="请输入游戏组"
        @on-change="handleGroup"
      />
      <drop-autoComplete label="上传者" member :width="120" :label-width="55" placeholder="请输入姓名" @on-change="handleOpen" />
      <drop-autoComplete label="标签" labels :width="180" :default-option="defaultLabels" placeholder="全部" @on-change="handleLabel" />
      <FormItem label="尺寸">
        <Select v-model="wide" :disabled="disabKey" style="width: 80px">
          <Option :value="1">456 X 300</Option>
          <Option :value="2">1280 X 720</Option>
          <Option :value="3">720 X 1280</Option>
          <Option :value="0">其他</Option>
        </Select>
      </FormItem>
      <FormItem label="" :label-width="0">
        <Input
          v-if="!disabKey"
          v-model.trim="keyword"
          placeholder="请输入素材名称"
          style="width: 150px"
          search
          @on-focus="focus = true"
          @on-blur="focus = false"
          @on-keypress="handlePress"
        />
      </FormItem>
      <Button type="primary" @click="query" :disabled="groupType === 'smart'" class="m-search-btn">查询</Button>
    </Form>
    <div class="radio-switch">
      <RadioGroup v-model="groupType" class="radio-switch-groups" @on-change="getOnline">
        <Radio v-for="(t, i) in method" :key="i" :label="t.key" :disabled="t.key !== type && t.key !== 'smart'">{{ t.value }}</Radio>
        <Radio label="onlineImage" :disabled="['double', 'group', 'video'].includes(type)">头条图片</Radio>
        <Radio label="onlineVideo" :disabled="['image', 'large', 'double', 'group', 'logo'].includes(type)">头条视频</Radio>
      </RadioGroup>
      <div class="switch-list">
        <div v-if="showOrList && groupType !== 'smart' && groupType !== 'onlineImage' && groupType !== 'onlineVideo'" class="data-pick">
          <DateRangePicker v-model="datetime" :clearable="false" @change="handleDatetime" style="width: 220px"></DateRangePicker>

          <!-- <date-pick
            ref="datepick"
            type="daterange"
            :value="datetime"
            :options="datetimeOption"
            :transfer="false"
            confirm
            split-panels
            placement="bottom-end"
            placeholder="请选择查询日期范围"
            style="width: 180px"
            @on-change="handleDatetime"
            @on-ok="confirmDatetime"
            @on-clear-shortcut="clearShortCut"></date-pick> -->
        </div>
        <Icon
          v-if="groupType !== 'smart' && groupType !== 'onlineImage' && groupType !== 'onlineVideo'"
          :type="showOrList ? 'md-list' : 'md-apps'"
          size="32"
          color="#676767"
          style="cursor: pointer"
          @click.stop="switchList"
        />
      </div>
    </div>
    <div
      v-if="showOrList && groupType !== 'smart' && groupType !== 'onlineImage' && groupType !== 'onlineVideo'"
      v-loading="!show"
      class="image-box table-box"
    >
      <material-tabel
        ref="materialTable"
        v-model="selection"
        :loading="show"
        :columns="columns"
        :data="tableList"
        :multiple="multiple"
        @on-refresh="getListData"
        @on-sort="sortTable"
      />
    </div>
    <!-- 智能封面 -->
    <div v-else-if="groupType === 'smart'" v-loading="!show" class="image-box">
      <div class="c-list-empty" v-if="!smartList.length">
        <Icon type="ios-filing-outline" size="100" color="#efefef" />
      </div>
      <div class="image-wrapper" v-for="(t, idx) in smartList" :key="idx" @click="selectWrap(idx)">
        <div class="image-item image-item-large">
          <img :src="t.url" :class="{ 'vertical-img': t.height > t.width }" />
          <span class="image-hover-txt">{{ t.width }}×{{ t.height }}</span>
        </div>
        <span v-if="t.check" class="image-check">
          <Icon type="md-checkmark-circle" size="24" color="#00FA9A" />
        </span>
      </div>
    </div>
    <div v-else v-loading="!show" class="image-box">
      <div class="c-list-empty" v-if="!caohuaMedia.length">
        <Icon type="ios-filing-outline" size="100" color="#efefef" />
      </div>
      <div class="image-wrapper" v-for="(item, idx) in caohuaMedia" :key="item.id || idx" @click="selectWrap(idx)">
        <template v-if="type === 'video'">
          <div class="c-item-v" v-for="t in item.items" :key="t.id">
            <div class="c-item-bg">
              <img v-if="t.height > t.width" :src="t.cover_url" alt="" />
            </div>
            <div class="image-item" @mouseenter="$set(t, '_hoverState', true)" @mouseleave="$set(t, '_hoverState', false)">
              <Row class-name="c-video-title">
                <Col span="18">
                  <p class="m-name">
                    <Tooltip :content="t.name" transfer placement="top-start">{{ t.name }}</Tooltip>
                  </p>
                  <p>{{ `${t.width} x ${t.height}` }}，{{ t.size | fileSize }}</p>
                </Col>
                <Col span="6" class-name="c-video-select">
                  <span :class="{ 'c-color-check': item.check }">选择</span>
                  <Icon
                    v-if="item.check"
                    type="md-checkmark-circle"
                    size="20"
                    color="#00FA9A"
                    style="display: inline-block; margin-top: -3px"
                  />
                  <Icon v-else type="md-checkmark-circle" size="20" color="#ddd" style="display: inline-block; margin-top: -3px" />
                </Col>
              </Row>
              <video :src="t.source_url" :controls="t._hoverState" :class="{ 'm-vertical-img': t.height > t.width }">
                您的浏览器不支持 video 标签
              </video>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="c-item-img" v-for="t in item.items" :key="t.id">
            <div class="c-item-bg">
              <img v-if="t.height > t.width" :src="t.cover_url" alt="" />
            </div>
            <div class="image-item" :class="{ 'image-item-logo': categroy === 8 }">
              <img :src="t.cover_url" :class="{ 'vertical-img': t.height > t.width, 'm-square-img': t.height === t.width }" />
              <Row :gutter="12" class-name="c-item-title">
                <Col span="17" class-name="c-hover-l">
                  <Tooltip :content="t.name" transfer placement="top-start"
                    ><span>{{ t.name }}</span></Tooltip
                  >
                </Col>
                <Col span="7" class-name="c-hover-r">
                  <span>{{ t.size | fileSize }}</span>
                </Col>
              </Row>
              <span class="image-hover-txt">{{ t.width }}×{{ t.height }}</span>
            </div>
            <span v-if="item.check" class="image-check">
              <Icon type="md-checkmark-circle" size="24" color="#00FA9A" />
            </span>
          </div>
        </template>
      </div>
    </div>
    <Page
      v-if="groupType !== 'smart'"
      :current.sync="pageIndex"
      :total="total"
      :page-size="pageSize"
      size="small"
      show-total
      @on-change="changePageIndex"
      class="page-index"
    />

    <template slot="footer">
      <Button type="default" @click="cancel">取消</Button>
      <Button type="primary" @click="asyncUpload">确定</Button>
    </template>
  </Modal>
</template>
<script>
import moment from 'moment'
import Cookies from 'js-cookie'
import { trim, isArray, debounce } from '@/common/js/utils'
import { getCookie, setLocal, getLocal, rmLocal } from '@/common/js/api'
import columns from '@/views/create/toutiao_local/components/idea/data/material_column'
import { getCaoHuaMedia, uploadCaoHuaMedia, getCaoHuaMediaData } from '@/api/common.model'
import { queryCoverVideo } from '@/api/toutiao.model'
import DropAutoComplete from '@/components/dropdown/'
import DateRangePicker from '@/components/date-range-picker/index.vue'

import MaterialTabel from '@/views/create/toutiao_local/components/idea/material-table'
export default {
  name: 'uploader',
  components: { DropAutoComplete, DateRangePicker, MaterialTabel },
  props: {
    value: {
      type: Boolean
    },
    type: {
      type: String
    },
    width: {
      type: [Number, String]
    },
    height: {
      type: [Number, String]
    },
    smart: {
      type: [String, Number]
    },
    multiple: {
      type: Boolean,
      default: false
    },
    mediaId: {
      type: [Number, String]
    },
    accountId: {
      type: [Number, String]
    }
  },
  computed: {
    state: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    categroy() {
      const method = this.method.filter((ret) => ret.key === this.type)
      const pop = method.pop()
      return pop.id
    },
    pageSize() {
      if (this.categroy === 3) return 3
      else if (this.categroy === 8) return 18
      else return 12
    },
    disabKey() {
      return ['onlineImage', 'onlineVideo', 'smart'].includes(this.groupType)
    }
  },
  methods: {
    switchList() {
      this.showOrList = !this.showOrList
      this.query()
    },
    query() {
      if (!this.state) return
      if (this.showOrList) this.getListData()
      else this.getData()
    },
    // 请求数据
    getData() {
      const { width, height } = this.getSize()
      if (width && typeof width !== 'number') this.$Message.warning('尺寸宽度不能是非数字')
      if (height && typeof height !== 'number') this.$Message.warning('尺寸高度不能是非数字')
      let params = {
        account: this.accountId,
        id: this.categroy,
        gameId: this.gameId,
        gameGroupId: this.gameGroupId,
        mediaId: this.mediaId,
        labels: this.labels,
        openId: this.openId,
        keyword: trim(this.keyword),
        width,
        height,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        lauchFlag: 1
      }
      if (this.groupType === 'onlineVideo') params = Object.assign(params, { id: 6 })
      else if (this.groupType === 'onlineImage') params = Object.assign(params, { id: 7 })
      // 查询素材与推荐封面
      this.show = false
      this.caohuaMedia = []
      console.log(params)
      if (this.smart) {
        Promise.all([getCaoHuaMedia(params), queryCoverVideo({ account: this.accountId, id: this.smart })])
          .then((data) => {
            this.show = true
            const [caohuaMediaData, smartData] = data
            smartData && (this.smartList = smartData)
            if (caohuaMediaData && isArray(caohuaMediaData.list)) {
              this.caohuaMedia = caohuaMediaData.list
              this.total = caohuaMediaData.page_info.total_number
            }
          })
          .catch((err) => {
            console.log(err)
          })
      } else {
        getCaoHuaMedia(params).then((data) => {
          if (typeof data !== 'symbol') this.show = true
          if (data && data.list && data.page_info) {
            this.caohuaMedia = data.list
            this.total = data.page_info.total_number
          }
        })
      }
    },
    getListData() {
      const { width, height } = this.getSize()
      if (width && typeof width !== 'number') this.$Message.warning('尺寸宽度不能是非数字')
      if (height && typeof height !== 'number') this.$Message.warning('尺寸高度不能是非数字')
      const params = {
        account: this.accountId,
        id: this.categroy,
        gameId: this.gameId,
        gameGroupId: this.gameGroupId,
        mediaId: this.mediaId,
        labels: this.labels,
        openId: this.openId,
        keyword: trim(this.keyword),
        width,
        height,
        beginTime: this.datetime[0],
        endTime: this.datetime[1],
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        sort: this.sort,
        order: this.order
      }
      // 查询素材与推荐封面
      this.show = false
      this.tableList = []
      getCaoHuaMediaData(params).then((data) => {
        if (typeof data !== 'symbol') this.show = true
        if (data && data.list && data.page_info) {
          this.tableList = data.list
          this.total = data.page_info.total_number
        }
      })
    },
    getSize() {
      let width
      let height
      switch (this.wide) {
        case 1:
          width = 456
          height = 300
          break
        case 2:
          width = 1280
          height = 720
          break
        case 3:
          width = 720
          height = 1280
          break
        default:
          width = this.width || ''
          height = this.height || ''
          break
      }
      return { width, height }
    },
    getOnline(val) {
      if (val !== 'smart') {
        this.pageIndex = 1
        this.query()
      }
      this.keyword = ''
    },
    // 默认初始化
    bindGetData(e) {
      if (e) {
        const index = this.method.findIndex((ret) => ret.key === 'smart')
        if (index > -1) this.method.splice(index, 1) // 增加智能封面
        if (this.smart) {
          this.method.push({
            id: 5,
            key: 'smart',
            value: '推荐封面'
          })
          this.groupType = 'smart'
        } else {
          this.groupType = this.type
        }
        if (!this.smartList.length && !this.caohuaMedia.length && !this.tableList.length) this.query()
      } else {
        this.pageIndex = 1
        this.wide = ''
        this.keyword = ''
        this.smartList = []
        this.caohuaMedia = []
        this.tableList = []
        this.selection = []
      }
    },
    setOperatorStorage(name, value) {
      const account = Cookies.get('ch_op_id')
      const storage = getLocal(name) || {}
      if (account) {
        storage[account] = value
        setLocal(name, storage)
      }
    },
    setGameId() {
      const account = Cookies.get('ch_op_id')
      const storage = getLocal('select-uploader')
      const labels = getLocal('select-uploader-label')
      const group = getLocal('select-uploader-group')
      this.defaultGameId = storage && storage[account] ? storage[account] : getCookie('TOUTIAO_IDEA_GAME')
      this.defaultGameGroupId = group && group[account] ? group[account] : null
      this.defaultLabels = labels && labels[account] ? labels[account] : ''
    },
    changePageIndex(index) {
      this.pageIndex = index
      this.query()
    },
    handleGame(item) {
      this.gameId = item.id
    },
    handleGroup(item) {
      this.gameGroupId = item.id
    },
    handleOpen(item) {
      this.openId = item.id
    },
    handleLabel(item) {
      this.labels = item
    },
    handleDatetime(dates) {
      const [start, end] = dates
      const limitDate = moment(end).subtract(90, 'days')

      if (limitDate.isAfter(start)) {
        this.$Message.warning('日期范围不能超过90天！')
        const newDate = limitDate.format('YYYY-MM-DD')
        this.datetime = [newDate, end]
      }

      this.query()
    },
    sortTable(params) {
      const { sort, order } = params
      this.sort = sort
      this.order = order
      this.pageIndex = 1
      this.getListData()
    },
    selectWrap(index) {
      const data = this.groupType === 'smart' ? this.smartList : this.caohuaMedia
      if (this.multiple) {
        // 多选
        const { check } = data[index]
        this.$set(data[index], 'check', !check)
      } else {
        this.caohuaMedia.forEach((ret) => {
          ret.check && this.$set(ret, 'check', false)
        })
        this.smartList.forEach((ret) => {
          ret.check && this.$set(ret, 'check', false)
        })
        this.$set(data[index], 'check', true)
      }
    },
    handlePress(e) {
      if (e.keyCode === 13) {
        this.pageIndex = 1
        this.query()
      }
    },
    enterSubmit(e) {
      if (this.value && !this.focus && e.keyCode === 13) {
        let urls
        const data = this.groupType === 'smart' ? this.smartList : this.caohuaMedia
        const isk = data.filter((ret) => ret.check)
        const iskCopy = JSON.parse(JSON.stringify(isk))
        const select = iskCopy.pop()
        if (select && select.items && select.items.length) {
          urls = select.items.map((ret) => ret.source_url).join(',')
        } else if (select) {
          urls = select.url
        }
        if (!urls) {
          this.$Message.warning('您未选择一个媒体素材或选择的素材信息有误')
          return false
        }
        this.asyncUpload()
      }
    },
    // 异步提交
    asyncUpload() {
      let imageMode
      let width
      let height
      let urls
      let coverUrls
      const data = this.groupType === 'smart' ? this.smartList : this.caohuaMedia
      const isk = this.showOrList ? this.selection : data.filter((ret) => ret.check)
      const iskCopy = JSON.parse(JSON.stringify(isk))
      const select = iskCopy.pop()

      if (select && select.items && select.items.length) {
        urls = select.items.map((ret) => ret.source_url).join(',')
        coverUrls = select.items.map((ret) => ret.cover_url).join(',')
        width = select.items[0].width
        height = select.items[0].height
      } else if (select) {
        urls = select.url
        width = select.width
        height = select.height
      }
      if (!urls) {
        this.$Message.warning('您未选择一个媒体素材或选择的素材信息有误')
        this.$emit('on-upload', null)
        return false
      }
      // 上传模式
      switch (this.groupType) {
        case 'large':
          if (width && height > width) imageMode = 'CREATIVE_IMAGE_MODE_LARGE_VERTICAL'
          else imageMode = 'CREATIVE_IMAGE_MODE_LARGE'
          break
        case 'video':
          if (width && height > width) imageMode = 'CREATIVE_IMAGE_MODE_VIDEO_VERTICAL'
          else imageMode = 'CREATIVE_IMAGE_MODE_VIDEO'
          break
        case 'smart':
          if (width && height > width) imageMode = 'CREATIVE_IMAGE_MODE_VIDEO_VERTICAL'
          else imageMode = 'CREATIVE_IMAGE_MODE_VIDEO'
          break
        case 'group':
          imageMode = 'CREATIVE_IMAGE_MODE_GROUP'
          break
        case 'onlineVideo':
          if (width && height > width) imageMode = 'CREATIVE_IMAGE_MODE_LARGE_VERTICAL'
          else imageMode = 'CREATIVE_IMAGE_MODE_LARGE'
          break
        case 'onlineImage':
          if (this.type === 'large') {
            if (width && height > width) imageMode = 'CREATIVE_IMAGE_MODE_LARGE_VERTICAL'
            else imageMode = 'CREATIVE_IMAGE_MODE_LARGE'
          } else imageMode = 'CREATIVE_IMAGE_MODE_SMALL'
          break
        case 'logo':
          imageMode = 'CREATIVE_IMAGE_MODE_LOGO'
          break
        default:
          imageMode = 'CREATIVE_IMAGE_MODE_SMALL'
          break
      }
      // 视频创封面与视频源
      if (this.groupType === 'video') {
        this.$Spin.show()
        uploadCaoHuaMedia({
          account: this.accountId,
          id: this.mediaId,
          type: 2,
          urls,
          image_mode: imageMode
        }).then((data) => {
          if (!data) {
            this.$Spin.hide()
            console.error('上传视频源失败')
            return
          }
          if (isArray(data) && data.length) {
            data = data.map((ret) => {
              ret.image_mode = imageMode
              return ret
            })
          }
          const res = { type: 'video', video: data }
          if (width && height > width) imageMode = 'CREATIVE_IMAGE_MODE_LARGE_VERTICAL'
          else imageMode = 'CREATIVE_IMAGE_MODE_LARGE'
          // 连着上传封面
          uploadCaoHuaMedia({
            account: this.accountId,
            id: this.mediaId,
            type: 1,
            urls: coverUrls,
            image_mode: imageMode
          }).then((resdata) => {
            if (!resdata) {
              this.$Spin.hide()
              console.error('上传视频的封面时失败')
              return
            }
            this.$Spin.hide()
            if (isArray(resdata) && resdata.length) {
              resdata = resdata.map((ret) => {
                ret.image_mode = imageMode
                return ret
              })
            }
            this.$emit('on-upload', Object.assign({}, { cover: resdata }, res))
          })
        })
      } else if (this.groupType === 'onlineVideo') {
        // 上面选中视频
        if (select && select.items && select.items.length) {
          const onlineVideoSelect = select.items.pop()
          const hasErr =
            onlineVideoSelect.size > 102400000 ||
            (onlineVideoSelect.width !== 1280 &&
              onlineVideoSelect.height !== 720 &&
              onlineVideoSelect.height !== 1280 &&
              onlineVideoSelect.width !== 720)
          const data = Object.assign(onlineVideoSelect, {
            url: onlineVideoSelect.source_url,
            poster_url: onlineVideoSelect.cover_url,
            msg: hasErr ? '视频，尺寸大小 1280x720 或 720x1280，大小100M以下' : '',
            image_mode:
              onlineVideoSelect.height > onlineVideoSelect.width ? 'CREATIVE_IMAGE_MODE_VIDEO_VERTICAL' : 'CREATIVE_IMAGE_MODE_VIDEO'
          })
          const res = { type: 'video', video: [data] }
          // 连着上传封面
          this.$Spin.show()
          uploadCaoHuaMedia({
            account: this.accountId,
            id: this.mediaId,
            type: 1,
            urls: coverUrls,
            image_mode: imageMode
          }).then((resdata) => {
            if (!resdata) {
              this.$Spin.hide()
              console.error('上传头条视频的封面时失败')
              return
            }
            this.$Spin.hide()
            if (isArray(resdata) && resdata.length) {
              resdata = resdata.map((ret) => {
                ret.image_mode = imageMode
                return ret
              })
            }
            this.$emit('on-upload', Object.assign({}, { cover: resdata }, res))
          })
        }
      } else {
        this.$Spin.show()
        uploadCaoHuaMedia({
          account: this.accountId,
          id: this.mediaId,
          type: 1,
          urls,
          image_mode: imageMode
        }).then((data) => {
          if (typeof data === 'symbol') return
          if (!data) {
            this.$Spin.hide()
            console.error('上传图片源失败')
            return
          }
          this.$Spin.hide()
          if (isArray(data) && data.length) {
            data = data.map((ret) => {
              ret.image_mode = imageMode
              return ret
            })
          }
          this.$emit('on-upload', data)
        })
      }
      // 记录上次成功gameId
      this.setOperatorStorage('select-uploader', this.gameId || -1)
      this.setOperatorStorage('select-uploader-group', this.gameGroupId || -1)
      if (isArray(this.labels) && this.labels.length) this.setOperatorStorage('select-uploader-label', this.labels.join(','))
      else rmLocal('select-uploader-label')
    },
    cancel() {
      this.$emit('input', false)
      this.$emit('on-cancel')
    }
  },
  filters: {
    fileSize(size) {
      if (typeof size !== 'number') return '0K'
      if (size > 104857) size = (size / 1048576).toFixed(2) + 'M'
      else if (size > 1000) size = (size / 1024).toFixed(2) + 'K'
      return size
    }
  },
  data() {
    // 初始化默认时间
    const yesterday = moment().subtract(1, 'days').format('YYYY-MM-DD')
    return {
      // 请求状态
      show: null,
      focus: null,

      // 分页信息
      total: 0,
      pageIndex: 1,

      // 下拉数据
      gameId: -1,
      gameGroupId: -1,
      openId: '',
      labels: [], // 标签

      // 宽高
      wide: '', // 尺寸
      keyword: '',
      showOrList: false, // 九宫格|列表展示
      defaultGameId: '',
      defaultLabels: '', // 本地存储Labels

      caohuaMedia: [],
      smartList: [],
      onlineVideoList: [],
      onlineImageList: [],
      groupType: '',
      method: [
        {
          id: 1,
          key: 'image',
          value: '单图'
        },
        {
          id: 1,
          key: 'large',
          value: '大图'
        },
        {
          id: 3,
          key: 'group',
          value: '三图'
        },
        {
          id: 8,
          key: 'logo',
          value: 'LOGO'
        },
        {
          id: 4,
          key: 'video',
          value: '视频'
        }
      ],
      columns: columns,
      tableList: [],
      selection: [], // 表格选中
      datetime: [yesterday, yesterday]
    }
  },
  watch: {
    gameId() {
      this.pageIndex = 1
      debounce(() => {
        this.query()
      }, 800)()
    },
    gameGroupId() {
      this.pageIndex = 1
      debounce(() => {
        this.query()
      }, 800)()
    },
    openId() {
      this.pageIndex = 1
      debounce(() => {
        this.query()
      }, 800)()
    },
    labels() {
      this.pageIndex = 1
      debounce(() => {
        this.query()
      }, 800)()
    }
  },
  created() {
    this.setGameId()
  },
  mounted() {
    // Enter Ok
    document.addEventListener('keydown', this.enterSubmit)
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.enterSubmit)
  }
}
</script>
<style lang="scss" scoped>
::v-deep .el-autocomplete-suggestion,
.el-popper {
  position: absolute !important;
  top: 30px !important;
  left: 0 !important;
}

::v-deep .ivu-radio-wrapper {
  min-width: 84px;
  text-align: center;
  user-select: none;
}

::v-deep .el-select__tags-text {
  max-width: 84px;
}

.radio-switch {
  display: flex;
  justify-content: space-between;

  .radio-switch-groups {
    display: flex;
    align-items: center;
  }

  .switch-list {
    display: inline-block;
    min-width: 192px;
    text-align: right;

    .data-pick {
      display: inline-block;
      margin-right: 12px;
    }
  }
}

.image-box {
  overflow-y: auto;
  scrollbar-width: thin;
  -webkit-overflow-scrolling: touch;
  width: 100%;
  height: 420px;
  margin: 12px 0 0 0;
  padding: 6px 10px;

  .image-wrapper {
    display: inline-block;
    position: relative;

    .c-item-v,
    .c-item-img {
      display: inline-block;
      position: relative;
      margin: 0 5px 5px 5px;
      background-color: #efefef;
      overflow: hidden;
    }

    .c-item-v {
      height: 193px;
    }

    .image-check {
      display: inline-block;
      width: 24px;
      height: 24px;
      position: absolute;
      z-index: 9;
      top: 6px;
      right: 12px;
    }

    .image-item {
      width: 279px;
      height: 157px;
      position: relative;
      z-index: 2;
      text-align: center;

      img,
      video {
        width: 100%;
        height: 100%;

        &.m-square-img {
          width: auto;
        }
      }

      .c-item-title {
        position: absolute;
        width: 100%;
        background-color: rgba(0, 0, 0, 0.6);
        color: #fff;
        right: 6px;
        line-height: 30px;
        bottom: 0;
        text-align: left;

        .c-hover-l {
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
        }

        .c-hover-r {
          text-align: right;
        }
      }

      .c-video-title {
        width: 100%;
        background-color: #000;
        color: #fff;
        text-align: left;
        line-height: 1;
        padding: 6px 0 6px 6px;

        p {
          margin: 0;
        }

        p.m-name {
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;

          width: 100%;
        }
      }

      .c-video-select {
        cursor: pointer;
        text-align: center;
        padding-top: 4px;

        .c-color-check {
          color: #00fa9a;
        }
      }

      .vertical-img {
        width: auto;
        height: 100%;
      }

      .image-hover-txt {
        display: inline-block;
        height: 24px;
        line-height: 24px;
        position: absolute;
        top: 0px;
        left: 3px;
        color: #efefef;
        font-size: 13px;
        text-shadow: 2px 1px 1px #232323;
      }
    }

    &:hover {
      .image-hover-txt {
        opacity: 1;
      }
    }

    .image-item-large {
      width: 268px;
      height: 152px;
      text-align: center;
      background-color: #f2f2f2;
    }

    .image-item-logo {
      width: 162px;
      height: 162px;
    }

    .c-item-bg {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: 1;

      img {
        width: 100%;
        height: auto;
        filter: blur(10px);
        transform: translateY(-25%);
      }
    }
  }

  .c-list-empty {
    min-height: 280px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}

.table-box {
  height: 420px;
  padding: 0;
}

.m-search-btn {
  float: right;
}

.page-index {
  margin-top: 12px;
  text-align: right;
}

.m-item {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.el-icon-circle-close-outline {
  cursor: pointer;
}
</style>
